/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mine': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M23 13v-2h-3.07a7.988 7.988 0 00-1.62-3.9l2.19-2.17-1.43-1.43-2.17 2.19A7.988 7.988 0 0013 4.07V1h-2v3.07c-1.42.18-2.77.74-3.9 1.62L4.93 3.5 3.5 4.93 5.69 7.1A7.988 7.988 0 004.07 11H1v2h3.07c.18 1.42.74 2.77 1.62 3.9L3.5 19.07l1.43 1.43 2.17-2.19c1.13.88 2.48 1.44 3.9 1.62V23h2v-3.07c1.42-.18 2.77-.74 3.9-1.62l2.17 2.19 1.43-1.43-2.19-2.17a7.988 7.988 0 001.62-3.9H23M12 8a4 4 0 00-4 4H6a6 6 0 016-6v2z"/>'
  }
})
